import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@app/environment/environment';
import { ComplainResponse } from '@app/models/complain.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ComplainService {
  private readonly http = inject(HttpClient);
  private readonly API_URL = environment.apiUrl;

  createComplaint(formData: FormData): Observable<ComplainResponse> {
    return this.http.post<ComplainResponse>(
      `${this.API_URL}/Complains`,
      formData,
    );
  }
}
